import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HolidayResponse } from '../interfaces/holiday-response.interface';

const API_URL = environment.apiUrl;

@Injectable({ providedIn: 'root' })
export class HolidayService {
  private http = inject(HttpClient);

  #holidayUrl = `${API_URL}/holidays`;

  getHolidays(): Observable<HolidayResponse[]> {
    return this.http.get<HolidayResponse[]>(`${this.#holidayUrl}/users`);
  }
}
